import { ODSStandardGlobalHeader } from "@telekom-ods/react-ui-kit";

const Header = (props) => {
	return <ODSStandardGlobalHeader></ODSStandardGlobalHeader>;
};

export default Header;
